<template>
  <div class="modal is-active">
  <div class="modal-background" @click="$emit('close')"></div>
    <div class="modal-content">
      <p class="image">
        <img v-if="url" :src="url">
        <span>{{mediaId}}</span>
      </p>
    </div>
    <button class="modal-close is-large" aria-label="close"></button>
  </div>
</template>

<script>
import featuredImage from '@/mixins/featuredImage'

export default {
  props: [
    'mediaId'
  ],
  data () {
    return {
      thumbSize: 2000
    }
  },
  mixins: [featuredImage]
}
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/shared/ImageModal.vue